import React from 'react';
import "@Styles/mandate.css";
import histroy_img from '@Images/history_img.png';
import arrowleft from "@Images/NewUI/Vector.png";
import { Link } from 'react-router-dom';


const LoanHistoryNoData = (props) => {
  return (
    <div id="background" className='main_div'>
        <div className="">
            <div className="pb-4">
            

            <div className="shadowlinepurebottomnew"> 
            <div
               style={{ display:"flex", justifyContent:'flex-start', alignItems:'center', padding:'30px 0px 30px'}}
               className='mll-25'
            >
                <a href="#" onClick={()=>{ props.history.goBack()}}>
              <img
                src={arrowleft}
                
              />
              </a>
              <h1
               className="boldheading mll-25" style={{ paddingLeft:"27px", color:'#152745', fontWeight:'700', fontSize:'25px'}}
              >
                {props?.PageText}
              </h1>
            </div>
            </div>
               
                <div className="wrapper-content history_sc">
                    <div className="card-height mt-5 px-4 pb-3 pt-1 w-100 mx-auto bg-white  max-width400">
                        <div className="d-flex flex-column justify-content-between">
                            <div className="pt-4 pb-5">
                                <img src={histroy_img} alt=''history/>
                                <p className='text-center'><strong>{props?.text}</strong></p>
                            </div>
                        </div>
                    </div>        
                </div>    
            </div>      
        </div> 
    </div>
    
  )
}

export default LoanHistoryNoData